import styled, { css } from 'styled-components';

export const SimpleGridWrapper = styled.div`
  [class*='SimpleGridstyle__SimpleGridColumn-sc'] {
    width: unset;
  }
`;

export const gridContainer = css`
  padding: 0.5em 0;
  text-align: center;
  align-items: center;
`;

export const buttonWithoutIconCSS = css`
  position: relative;
  cursor: pointer;
  width: fit-content;
`;

export const pillBetaCSS = css`
  margin-right: auto !important;
  padding: 0.5em 0;

  span {
    color: #ffffff !important;
    background-color: #007c92 !important;
    line-height: normal;
    padding: 10px 13px !important;
    border-radius: 35px !important;
    width: fit-content !important;
    font-size: 15px !important;
    font-family: 'Vodafone';
    font-weight: 400 !important;
    min-width: auto !important;
    height: auto !important;
    position: relative;
    border: none;
  }

  @media only screen and (max-width: 639px) {
    width: auto !important;
  }
`;

export const pillBetaTooltipCSS = css`
  span {
    &:before {
      content: '';
      position: absolute;
      display: block;
      width: 0px;
      right: -42px;
      top: 50%;
      border: 15px solid transparent;
      border-left: 0;
      transform: translate(calc(-100% - 5px), -50%);
      visibility: hidden;
    }
    &:after {
      content: attr(data-title);
      height: auto;
      left: 84px;
      width: 190px;
      padding: 12px;
      margin-right: auto;
      text-align: left;
      pointer-events: none;
      position: absolute;
      top: -20px;
      margin-left: 35px;
      font-family: 'Vodafone';
      font-size: 11px;
      font-weight: bold;
      line-height: 17px;
      visibility: hidden;
    }
    &:hover {
      &:after {
        visibility: visible;
      }
      &:before {
        visibility: visible;
      }
    }
  }
`;

export const buttonWithIconCSS = css`
  position: relative;
  cursor: pointer;
  padding-left: 3em;
  width: fit-content;
`;

// Button row alignment. NB - centre is the default (i.e. neither left nor right).
export const buttonAlignmentLeft = css`
  margin-inline-end: auto !important; // because the margin 0 from ws2 seems to override
`;

export const buttonAlignmentRight = css`
  margin-left: auto !important; // because the margin 0 from ws2 seems to override
`;

export const buttonMarginLeft = css`
  margin-left: 20px;
  @media only screen and (max-width: 639px) {
    margin-left: unset;
  }
`;
